/**
 * Error from a Stocky migration API call that carries the HTTP status.
 *
 * The wizard needs to tell 409 — an import is already running for this store,
 * which the backend's run lock reports on purpose — apart from a genuine
 * failure, so it can show information rather than a red alert.
 *
 * Lives in its own module because `stocky_migration.ts` already declares
 * `StockyMigrationModel` and the lint config allows one class per file.
 */
export class StockyRequestError extends Error {
  public statusCode?: number;

  /**
   * The import already in progress, when the backend named one on a 409.
   *
   * Optional on purpose: the run lock can be held by a run that died before it
   * created its job, so a 409 does not guarantee there is a job to watch.
   */
  public jobId?: string;

  constructor(message: string, statusCode?: number, jobId?: string) {
    super(message);
    this.name = 'StockyRequestError';
    this.statusCode = statusCode;
    this.jobId = jobId;
    // Required for `instanceof` to work when the build targets ES5.
    Object.setPrototypeOf(this, StockyRequestError.prototype);
  }
}
